import { render, staticRenderFns } from "./famAseg.vue?vue&type=template&id=3ce7c48e&scoped=true"
import script from "./famAseg.vue?vue&type=script&lang=js"
export * from "./famAseg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ce7c48e",
  null
  
)

export default component.exports